/*************************************************/
/* CARDS SLIDER (mobile only)                    */
/*************************************************/
import Swiper from "swiper";
import { Scrollbar } from "swiper/modules";

// The cards component can opt in to "Display as slider on mobile". On mobile the
// grid becomes a horizontal, drag-only Swiper with a progress bar; above mobile the
// Swiper is destroyed and the CSS grid takes over again. The list/slide classes are
// reused as Swiper's wrapper/slide (wrapperClass/slideClass) so the same markup
// serves both layouts without duplicated DOM.
export function cardsSlider() {
    const roots = document.querySelectorAll(".cards--slider-mobile");
    if (!roots.length) return;

    // max-S breakpoint (see _mixins.scss / $breakpoint-S).
    const mobile = window.matchMedia("(max-width: 666px)");
    const instances = new Map();

    const init = () => {
        roots.forEach(root => {
            const swiperEl = root.querySelector(".cards__slider");
            if (!swiperEl || instances.has(swiperEl)) return;

            instances.set(swiperEl, new Swiper(swiperEl, {
                modules: [Scrollbar],
                wrapperClass: "cards__list",
                slideClass: "card",
                speed: 400,
                slidesPerView: 1.15,
                spaceBetween: 15,
                watchOverflow: true,
                scrollbar: {
                    el: root.querySelector(".cards__scrollbar"),
                    draggable: true,
                },
            }));
        });
    };

    const destroy = () => {
        instances.forEach((swiper, el) => {
            swiper.destroy(true, true);
            instances.delete(el);
        });
    };

    const handle = event => (event.matches ? init() : destroy());

    handle(mobile);
    mobile.addEventListener("change", handle);
}
